<template>
<div class="odr-block__wrap">
    <div v-if="sections_eSections.header">
        <tpl :content="sections_eSections.header"/>
    </div>
    <div class="odr-monthview">
        <div data-sticky-area="calendar" class="odr-monthview__calendar">
            <sticky :disabled="dimensionsMode !== 'l'" sticky-area="calendar" :add-fixed-top="20">
                <calendar v-model="selectedDate"
                          :view-date="viewDate"
                          :bright="true"
                          :no-before="slots_data.availability.from"
                          :no-after="slots_data.availability.to"
                          :available-dates="datesWithSlots"
                          @showingDates="showingDatesHandler"/>
                <linearProgress v-if="slots_daysFetching.length && slots_slotsFetching"/>
                <div v-if="sections_eSections.footer">
                    <tpl :content="sections_eSections.footer"/>
                </div>
            </sticky>
        </div>
        <div v-if="allSlots.length" class="odr-monthview__slots">
            <div class="odr-options-slot">
                <div class="odr-options-slot__header">
                    {{ formattedDate }}
                </div>
                <button v-for="slot in showSlots"
                        :key="slot.value"
                        type="submit"
                        class="odr-options-slot__item"
                        :class="{'odr-options-slot__item_choosed': question.value ? slot.datetime === question.value.datetime : false}"
                        @click="slots_selectSlot(slot)">
                    <div class="odr-options-slot__time">
                        {{ formatTime(slot.time) }}
                    </div>
                    <div v-if="slot.info" class="odr-options-slot__info">
                        <tpl :content="slot.info"/>
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/scss/blocks/block.scss';
import '@/scss/blocks/monthview.scss';
import '@/scss/blocks/options-slot.scss';

import slots from '@/utils/mixins/slots';

import { date2str, str2date, DATETIME_FORMAT, TIME_FORMAT } from '@/utils/format';
import calendar from '@/vue/blocks/calendar';
import linearProgress from '@/vue/markup/linear-progress';
import sticky from '@/vue/markup/sticky';
import sections from '@/utils/mixins/appoint-sections';
import { mapState } from 'vuex';

export default {
    mixins: [slots, sections],
    props: ['question', 'stateId'],
    data () {
        return {
            selectedDate: undefined,
            dates: [],
        };
    },
    mounted () {
        let firstDate = this.viewDate ? this.datesWithSlots.find(date => str2date(date) > str2date(this.viewDate)) : this.datesWithSlots[0];

        this.selectedDate = this.question.value
            ? date2str(str2date(this.question.value.date + 'T' + this.question.value.time, DATETIME_FORMAT))
            : firstDate;

        this.selectDate(this.selectedDate || firstDate);
    },
    computed: {
        ...mapState('dimensions', {
            dimensionsMode: 'mode',
        }),
        viewDate: {
            get () {
                return this.question.data.effective && this.question.data.effective.viewDate ||
                       this.question.data.availability && this.question.data.availability.from ||
                       date2str(new Date());
            },
            set (value) { this.slots_setEffective('viewDate', value); },
        },
        formattedDate () {
            return this.selectedDate && date2str(str2date(this.selectedDate), '#day, %d #month');
        },
        allSlots () {
            let slots = [];
            this.slots_data.slotCards.forEach(card => {
                slots = slots.concat(card.slots.map(slot => ({
                    date: slot.datetime.split('T')[0],
                    time: slot.datetime.split('T')[1],
                    datetime: slot.datetime,
                    // cardInfo: card.info,
                    info: slot.info,
                    value: slot.value,
                })));
            });

            slots = slots.sort((a, b) => {
                if (a.time === b.time) {
                    return 0;
                }

                if (str2date(a.time, TIME_FORMAT) > str2date(b.time, TIME_FORMAT)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            return slots;
        },
        showSlots () {
            return this.allSlots.filter(slot => slot.date === this.selectedDate);
        },
        datesWithSlots () {
            return this.allSlots
                .map(slot => slot.date)
                .filter((date, index, array) => array.indexOf(date) === index)
                .sort((a, b) => str2date(a) > str2date(b) ? 1 : -1);
        },
    },
    methods: {
        showingDatesHandler (dates) {
            this.dates = dates;
            this.selectDate(dates[0]);
        },
        selectDate (dateString) {
            this.viewDate = dateString;
        },
        formatTime (time) {
            if (this.$root.appConfig.ampm) {
                return date2str(str2date(time, '%H:%M'), '%h:%M #ampm');
            }

            return time;
        },
    },
    components: {
        calendar,
        sticky,
        linearProgress,
        tpl: require('@/vue/markup/tpl.vue').default,
    },
};
</script>
